import { FETCH_WALLET_TXNS, FETCH_WALLET_TXNS_SUCCESS } from "../actionTypes";

export function fetchWalletTxns(data) {
  return {
    data,
    type: FETCH_WALLET_TXNS
  };
}

export function fetchWalletTxnsSuccess(data, modalShow) {
  return {
    data,
    modalShow,
    type: FETCH_WALLET_TXNS_SUCCESS
  };
}